// extracted by mini-css-extract-plugin
export default {"canvasContainer":"VideoController_canvasContainer__kJYMa","navigationButtons":"VideoController_navigationButtons__zNAfC","navButton":"VideoController_navButton__q6Nfb"};